import React from "react";

export const Logo = ({ variant = "dark", small = false, showLicencia = false }) => {
  const color = variant === "light" ? "#FBF7F0" : "#0B1B2E";
  return (
    <div className="inline-flex flex-col items-start leading-none select-none" data-testid="cometa-logo">
      <div className="flex items-end gap-1" style={{ color }}>
        <span
          className="font-script"
          style={{ fontSize: small ? "1.4rem" : "1.9rem", fontWeight: 700, lineHeight: 0.9 }}
        >
          Doctora
        </span>
        <span className="cometa-star" aria-hidden="true" style={{ width: small ? "0.7rem" : "0.9rem", height: small ? "0.7rem" : "0.9rem", marginBottom: small ? "6px" : "10px" }} />
      </div>
      <div
        className="font-display tracking-tight"
        style={{ color, fontWeight: 900, fontSize: small ? "1.6rem" : "2.4rem", lineHeight: 0.85, letterSpacing: "-0.03em" }}
      >
        COMETA
      </div>
      {showLicencia && (
        <div className="mt-1 text-[0.65rem] tracking-[0.35em]" style={{ color: color, opacity: 0.75 }}>
          LIC. ARACELI LUGO
        </div>
      )}
    </div>
  );
};
